import { BlockTitle, Block, Button, f7 } from 'framework7-react';
import React from 'react';

function NetworkError(props) {
  return (
    <div style={{ height: '100%', display: 'grid', placeItems: 'center' }}>
      <BlockTitle>Connection Error</BlockTitle>
      <Block strong inset>
        An Error has occured. This is due to your device not having access to
        the internet. Please check your device connection and try again
      </Block>
      <Button
        large
        small
        onClick={() => {
          f7.views.main.router.refreshPage();
        }}>
        Reload
      </Button>
    </div>
  );
}

export default NetworkError;
